import combineMaintenanceData from "../utils/combineMaintenanceData";
import { useMaintenanceWorkOrder } from "@/hooks/maintenance/useMaintenanceWorkOrder";
import { useMaintenanceWorkOrderJob } from "@/hooks/maintenance/useMaintenanceWorkOrderJob";
import { MaintenanceDisplayData } from "@/models/MaintenanceDisplayData";

export const useMaintenanceData = (): { data: MaintenanceDisplayData[] } => {
  const { data: workOrders = [] } = useMaintenanceWorkOrder();
  const { data: workOrderJobs = [] } = useMaintenanceWorkOrderJob(undefined, false);
  const data = combineMaintenanceData(workOrders, workOrderJobs);

  return {
    data,
  };
};
